import React from 'react';
import './ResourcesSection.css';

const ResourcesSection = () => {
  return (
    <section id="resources" className="resources-section">
      <div className="soil-steward-band">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column is-6">
              <div className="data-journey" aria-label="Workshop data journey">
                <div className="journey-main">
                  <div className="journey-node">
                    <span className="icon is-large"><i className="fas fa-users fa-2x"></i></span>
                    <span>Workshop insights</span>
                  </div>
                  <span className="journey-arrow" aria-hidden="true">→</span>
                  <div className="journey-node">
                    <span className="icon is-large"><i className="fas fa-chart-pie fa-2x"></i></span>
                    <span>Analysis</span>
                  </div>
                  <span className="journey-arrow" aria-hidden="true">→</span>
                  <div className="journey-node">
                    <span className="icon is-large"><i className="fas fa-id-card fa-2x"></i></span>
                    <span>Personas</span>
                  </div>
                </div>
                <div className="journey-branch">
                  <div className="journey-targets">
                    <div className="journey-target journey-target-diagonal">
                      <span className="journey-arrow journey-arrow-diagonal" aria-hidden="true">↙</span>
                      <div className="journey-node journey-node-muted">
                        <span className="icon is-large"><i className="fas fa-tools fa-2x"></i></span>
                        <span>Other initiatives</span>
                      </div>
                    </div>
                    <div className="journey-target">
                      <span className="journey-arrow journey-arrow-down" aria-hidden="true">↓</span>
                      <div className="journey-node journey-node-highlight">
                        <span className="icon is-large"><i className="fas fa-seedling fa-2x"></i></span>
                        <span>Soil Steward</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="column">
              <div className="content">
                <h2 className="title">What happens with the workshop data?</h2>
                <p className="subtitle is-5">Workshop insights are helping BENCHMARKS deliver on stakeholder needs.</p>
                <p>
                  The workshop data has been used beyond analysis and reporting. Insights from 500+ stakeholders helped create soil health personas that represent key perspectives, needs, and challenges across Europe. These personas initially informed the development of the Soil Steward platform, and are now also shared as a standalone resource that other soil health initiatives can reuse.
                </p>
                <div className="buttons mt-4">
                  <a className="button has-background-primary has-text-white" href="https://ecoenvai.ijs.si/benchmarks/soil-steward/" target="_blank" rel="noopener noreferrer">
                    Open Soil Steward
                  </a>
                  <a className="button is-light" href="https://ecoenvai.ijs.si/benchmarks/soil-steward/personas/" target="_blank" rel="noopener noreferrer">
                    Explore Soil Health Personas
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section">
        <div className="container">
          <div className='columns is-vcentered'>
          {/* <div className='column'>
            <h2 className="title">Get involved</h2>
            <p className="content">
              For those interested in diving deeper into our work, we invite you to explore the documents related to the workshops we've conducted. These materials offer insights into our methodologies, findings, and the collaborative efforts that drive our project forward.
            </p>
            <p className="content">
              Included are a typical workshop agenda, a comprehensive deliverable report detailing our findings and progress, and various documents that have guided our workshops.
            </p>
            <div className="content">
              <h3 className="mb-2 subtitle is-5">Resources:</h3>
              <ul>
                {/* <li><a href="/test.pdf">Typical Workshop Agenda</a></li>
                <li><a href="/test.pdf">Deliverable Report</a></li>
                <li><a href="/test.pdf">Anonymized data from all workshops</a></li>
              </ul>
              <h2 className="title">Join our community</h2>
              <p>We are considering starting a Europe-wide online community focused on soil health. This community would help stakeholders connect with each other across Europe, organize local events, share knowledge, and much more.</p>              
            </div>
            <a target="_blank" className="join-button button is-fullwidth is-large has-background-primary has-text-white pull-right" href={wsRAV.text_community_link ? wsRAV.text_community_link : "https://soilhealthbenchmarks.eu/events_by_country/"}>Join our community {wsRAV.text_workshop_country ? `in ${wsRAV.text_workshop_country}` : ""}</a>
          </div> */}
          <div className='column'>
            <figure className="image">
              <img id="community-image"
                src={process.env.PUBLIC_URL + "/join_community.png"}
                alt="Community sample drawing."
              />
            </figure>
            <div className="content">
              <p className="quote">“Every individual matters.<br/>Every individual has a role to play.<br/>Every individual makes a difference.”</p>
              <p className="quote-author">Jane Goodall, Ethologist and Conservationist</p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default ResourcesSection;
